'use strict';

window.jQuery = window.$ = require('jquery');
require('slick-carousel/slick/slick');
var processInclude = require('./util');
var { slickInit } = require("./components/slickCarousel");

$(document).ready(function () {
    // base
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));

    // custom
    processInclude(require('./components/menu'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/header'));
    processInclude(require('./components/search'));
    processInclude(require('./components/modal'));
    processInclude(require('./components/toolTip'));

    slickInit();
});

require('./thirdParty/bootstrap');
require('base/components/spinner');
require('./gtm/gtm');
